export * from './infosmail.component';
